import { Injectable } from '@angular/core';

@Injectable()
export class SortDirectionsConstants {
  public asc = 'asc';
  public desc = 'desc';
}
